module.exports = __webpack_public_path__ + "img/text-bg.172c35a9.png";